// styles
import styled from "styled-components";
import { mobile } from "../../../styles/responsive";
// types
import { TripCost} from "../../../types/common.types";
import formatNumberToString from "../../../utils/formatNumber";

interface Accounting {
    costs: TripCost[];
    grand_total: number
}

export default function AccountingComponent({accounting}: {accounting: Accounting}) {

    return (
        <Main>
            <div className="cost">
                <div className="header">
                    <div className="name">
                        Grand Total: {formatNumberToString(accounting.grand_total)}
                    </div>
                </div>
                <TableWrapper>
                    <Table>
                        <thead>
                            <tr>
                                <th>Cost</th>
                                <th>Total Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                accounting.costs.map((c, i) => {
                                    return <tr key={i}>
                                        <td>{c.name}</td>
                                        <td>{formatNumberToString(c.total)}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </TableWrapper>
            </div>
        </Main>
    )
}

const Main = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 90%;
    margin: auto;
    margin-bottom: 20px;
    ${mobile({
        width: '100%',
        padding: '0 10px'
    })}
    
    overflow: unset;
    
    .cost {
        background-color: ${props => props.theme.whiteBackground};
        border-radius: 10px;
        box-shadow: 0 3px 5px ${props => props.theme.blackTransparent};
        cursor: pointer;
        transition: all .3s ease;
        
        &:hover {
            box-shadow: 0 5px 10px ${props => props.theme.blackTransparent};
            transform: translateY(-3px);
        }
        
        .header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 10px 10px 0 0;
            position: relative;
            height: 80px;
            background-color: ${props => props.theme.black};
            color: ${props => props.theme.white};
            
            .name {
                flex: 1;
                text-align: center;
            }
            
            .actions {
                height: 100%;
                display: flex;
                gap: 5px;
                padding: 5px;
            }
        }
    }
`

const TableWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: visible;
    ${mobile({
        overflowX: 'scroll',
        '-webkit-overflow-scrolling': 'touch'
    })}
`

const Table = styled.table`
    border-collapse: collapse;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 600px;
    
    ${mobile({
        minWidth: '300px'
    })}
    
    thead {
        width: 100%;
        background-color: #FFFFFF;
        position: sticky;
        top: 0;
        z-index: 10;
        
        tr {
            background-color: #f9fafb;
        }
        
        th {
            font-weight: 600;
            font-size: 13px;
            padding: 12px 8px;
            background-color: #f9fafb;
            border-bottom: 2px solid #e5e7eb;
            white-space: nowrap;
            text-align: center;
            color: #374151;
            
            ${mobile({
                fontSize: '12px',
                padding: '10px 6px'
            })}
        }
    }
    
    tbody {
        tr {
            transition: background-color 0.2s ease;
            
            &:hover {
                background-color: #f9fafb;
            }
        }
    }
    
    td {
        text-align: center;
        padding: 12px 8px;
        border-bottom: 1px solid #f0f0f0;
        font-size: 13px;
        white-space: nowrap;
        color: #1f2937;
        
        ${mobile({
            fontSize: '12px',
            padding: '10px 6px'
        })}
        
        
        span {
            display: inline-block;
            line-height: 1.4;
        }
    }
    
    tr {
        height: auto;
        width: 100%;
    }
`